import { SYS_CHECKOUT } from '../constants/system-external-events';

/**
Takes data object from system-sdk checkout and creates checkout message for visa-sdk with
checkout event
 * @param {Object} data
 * @returns {Object} message
 */
const getCheckoutMessage = data => {
  return {
    data,
    type: SYS_CHECKOUT
  };
};

export default getCheckoutMessage;
